/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import { Button, Col, Container, Form, FormGroup, Input, Label, Row, FormFeedback } from 'reactstrap';
import * as React from 'react';
import { createJobAction, CreateJobActionParams, setShowCreateJobFormAction } from '../actions';
import { connect } from 'react-redux';
import { GlobalState } from '../../actions';
import { availableJobsSelector } from '../selectors';
import { Dispatch } from 'redux';
import { ServerType } from '../../System/systemConfig';

interface OwnProps {
    serverName: ServerType;
}

interface StateProps {
    availableJobs: string[];
}

interface DispatchProps {
    onCreate: (params: CreateJobActionParams) => void;
    onCancel: () => void;
}

type Props = OwnProps & StateProps & DispatchProps;

interface State extends CreateJobActionParams {
    jobErrorMessage: string;
}

const DEFAULT_VALUE = '<please select job>';

class JobCreate extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            jobId: '',
            immediately: false,
            seconds: '0',
            minute: '0',
            hours: '*',
            dayOfMonth: '*',
            months: '*',
            daysOfWeek: '?',
            years: '*',
            jobErrorMessage: ''
        } as State;

        this.handleChange = this.handleChange.bind(this);
        this.onCreate = this.onCreate.bind(this);
    }

    public handleChange(e: React.FormEvent<HTMLInputElement>) {
        if (e.currentTarget.type === 'checkbox') {
            this.setState(Object.assign({}, this.state, { [e.currentTarget.name]: e.currentTarget.checked }));
        } else {
            this.setState(Object.assign({}, this.state, { [e.currentTarget.name]: e.currentTarget.value }));
        }
        if (this.state.jobId === DEFAULT_VALUE) {
            this.setState(Object.assign({}, this.state, { jobErrorMessage: 'Please select a job from the list.' }));
        }
    }

    public onCreate() {
        if (this.state.jobId !== DEFAULT_VALUE) {
            const completeState = { ...this.state, serverName: this.props.serverName };
            const { jobErrorMessage, ...params } = completeState;
            this.props.onCreate(params);
            this.setState(Object.assign({}, this.state, { jobErrorMessage: '' }));
        } else {
            this.setState(Object.assign({}, this.state, { jobErrorMessage: 'Please select a job from the list.' }));
        }
    }

    public render() {
        return (
            <Container>
                <Form>
                    <FormGroup>
                        <Label for="jobId">Job</Label>
                        <Input
                            type="select"
                            id="jobId"
                            name="jobId"
                            placeholder="Please select ..."
                            onChange={this.handleChange}
                            value={this.state.jobId}
                            defaultValue={DEFAULT_VALUE}
                        >
                            {this.props.availableJobs &&
                                this.props.availableJobs.map(n => (
                                    <option key={n} value={n}>
                                        {n}
                                    </option>
                                ))}
                        </Input>
                        {this.state.jobErrorMessage && <FormFeedback>{this.state.jobErrorMessage}</FormFeedback>}
                    </FormGroup>
                    <FormGroup check={true}>
                        <Label for="immediately" check={true}>
                            <Input
                                type="checkbox"
                                id="immediately"
                                name="immediately"
                                onChange={this.handleChange}
                                checked={this.state.immediately}
                            />{' '}
                            Start Job immediately and only once?
                        </Label>
                    </FormGroup>
                    <Row>
                        <Col md={2}>
                            <FormGroup disabled={this.state.immediately}>
                                <Label for="seconds">Seconds</Label>
                                <Input
                                    type="text"
                                    id="seconds"
                                    name="seconds"
                                    onChange={this.handleChange}
                                    value={this.state.seconds}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={2}>
                            <FormGroup>
                                <Label for="minute">Minute</Label>
                                <Input
                                    type="text"
                                    id="minute"
                                    name="minute"
                                    onChange={this.handleChange}
                                    value={this.state.minute}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={2}>
                            <FormGroup>
                                <Label for="hours">Hours</Label>
                                <Input
                                    type="text"
                                    id="hours"
                                    name="hours"
                                    onChange={this.handleChange}
                                    value={this.state.hours}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={2}>
                            <FormGroup>
                                <Label for="dayOfMonth">Day of Month</Label>
                                <Input
                                    type="text"
                                    id="dayOfMonth"
                                    name="dayOfMonth"
                                    onChange={this.handleChange}
                                    value={this.state.dayOfMonth}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={2}>
                            <FormGroup>
                                <Label for="months">Months</Label>
                                <Input
                                    type="text"
                                    id="months"
                                    name="months"
                                    onChange={this.handleChange}
                                    value={this.state.months}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={2}>
                            <FormGroup>
                                <Label for="years">Years</Label>
                                <Input
                                    type="text"
                                    id="years"
                                    name="years"
                                    onChange={this.handleChange}
                                    value={this.state.years}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Button className="m-2" color="success" onClick={this.onCreate} active={true}>
                        Create Job
                    </Button>
                    <Button className="m-2" color="secondary" onClick={this.props.onCancel} active={true}>
                        Cancel
                    </Button>
                </Form>
            </Container>
        );
    }
}

const prepareAvailableJobList = (list: string[] | null): string[] => {
    let r: string[] = [];
    r.push(DEFAULT_VALUE);
    if (list) {
        list.forEach(l => r.push(l));
    }
    return r;
};

const mapStateToProps = (state: GlobalState, ownProps: OwnProps): StateProps => {
    return {
        availableJobs: prepareAvailableJobList(availableJobsSelector(state, ownProps.serverName))
    };
};

const mapDispatchToProps = (dispatch: Dispatch, ownProps: OwnProps): DispatchProps => {
    return {
        onCreate: (params: CreateJobActionParams) => {
            dispatch(createJobAction(params));
        },
        onCancel: () => dispatch(setShowCreateJobFormAction({ serverName: ownProps.serverName, show: false }))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(JobCreate);
